import { render, staticRenderFns } from "./SmsObserverEdit.vue?vue&type=template&id=20fefe98"
import script from "./SmsObserverEdit.vue?vue&type=script&lang=js"
export * from "./SmsObserverEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports